import { render } from "./TopTalent.vue?vue&type=template&id=5b63a8f5&scoped=true"
import script from "./TopTalent.vue?vue&type=script&lang=js"
export * from "./TopTalent.vue?vue&type=script&lang=js"

import "./TopTalent.vue?vue&type=style&index=0&id=5b63a8f5&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b63a8f5"]])

export default __exports__